import { useTheme } from "@emotion/react";
import { useAuth } from "../../context/Auth.context";
import { useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../context/App.context";
import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { SEND_EMAIL, SEND_TEXT } from "../../graphql/mutation/mutation";
import { CheckCircle } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import AppButton from "./AppButton.component";
import { NotificationContainer } from "react-notifications";
import { InputValidation } from "../../utils/InputValidationRegex";
import { appUrl, delay } from "../../utils/Utils";
import { useVerification } from "../../context/Verification.context";
import HocPopup from "../../hoc/hocPopup";
import Theme from "../../utils/Theme";
import useDebounce from "../../hook/useDebounce";

const INITIAL_CUSTOMER_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  mobileNumber: "",
};
const currentYear = new Date().getFullYear() + 1;

const RepullUsers = ({
  onClose,
  isURL = false,
  repull = false,
  customerId,
  customers,
  continueHandler,
  walkthrough,
}) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const verifications = useVerification();

  const app = useAppContext();

  const [saveCustomer, setSaveCustomer] = useState({
    email: false,
    continue: false,
    text: false,
  });
  const [customer, setCustomer] = useState(INITIAL_CUSTOMER_STATE);

  const [status, setStatus] = useState(null);

  const [loading, setLoading] = useState(false);
  const [debounceText, setDebounceText] = useState("");

  useEffect(() => {
    if (customers) {
      // const vehicleId = customers.vehicles.filter(
      //   (vehicle) => vehicle.vehicle_status_id === 1
      // );
      // console.log("fetchCustomers", vehicleId);

      setCustomer((prev) => ({
        ...prev,
        firstName: customers?.customer?.first_name,
        lastName: customers?.customer?.last_name,
        mobileNumber: customers?.contact?.mobile_number,
        email: customers?.contact?.email,
        userId: customerId,
      }));
    }
  }, [customers]);

  const [sendEmail, { loading: emailLoading, data: emailData }] = useMutation(
    SEND_EMAIL,
    {
      onCompleted: async (data) => {
        if (data) {
          setCustomer(INITIAL_CUSTOMER_STATE);
          await delay(1000);
          onClose();
        }
      },
    }
  );

  const [sendText, { loading: textLoading, data: textData }] = useMutation(
    SEND_TEXT,
    {
      onCompleted: async (data) => {
        if (data) {
          setCustomer(INITIAL_CUSTOMER_STATE);
          await delay(1000);
          onClose();
        }
      },
    }
  );

  const emailHandler = async (userId) => {
    if (
      !InputValidation.emailValidation(customer.email) &&
      customer.email !== ""
    ) {
      sendEmail({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              // vin: vehicleDetail.vin,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url: repull
              ? appUrl +
                `/verification/consent/${auth.user.user_id}/${
                  auth.user.dealership_id || params.dealershipId
                }/${customer.userId}/${app.fetchData.pageCount || 0}/${repull}?fct=true`
              : appUrl +
                `/verification/consent/${auth.user.user_id}/${
                  auth.user.dealership_id || params.dealershipId
                }/${customer.userId}/${walkthrough}/${
                  app.fetchData.pageCount || 0
                }/${repull}?service=1&fct=true`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: repull ? true : false,
          },
        },
      });
    }
  };

  const textHandler = async (userId) => {
    if (
      !InputValidation.numberValidation(customer.mobileNumber) &&
      customer.mobileNumber !== ""
    ) {
      sendText({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url: repull
              ? appUrl +
                `/verification/consent/${auth.user.user_id}/${
                  auth.user.dealership_id || params.dealershipId
                }/${customer.userId}/${app.fetchData.pageCount || 0}/${repull}?fct=true`
              : appUrl +
                `/verification/consent/${auth.user.user_id}/${
                  auth.user.dealership_id || params.dealershipId
                }/${customer.userId}/${walkthrough}/${
                  app.fetchData.pageCount || 0
                }/${repull}?service=1&fct=true`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: repull ? true : false,
          },
        },
      });
    }
  };

  useDebounce(
    () => {
      if (verifications?.status) {
        console.log("debounce");
        setDebounceText(
          "Verification Failed.Please reinitiate the verification process."
        );
        setTimeout(() => {
          setStatus(null);
          verifications.setStatus(null);
        }, 5000);
      }
    },
    60 * 1000,
    [status]
  );

  useEffect(() => {
    if (verifications.status) {
      setStatus(verifications.status);
      setLoading(false);
    }
    if (verifications.status === "NOT_AUTHENTICATED") {
      console.log("not authenticated");
      setTimeout(() => {
        setStatus(null);
        verifications.setStatus(null);
      }, 5000);
    }
  }, [verifications.status]);

  console.log("checkParams", verifications.status);

  useEffect(() => {
    if (saveCustomer.email) {
      console.log("insideUseEffect111", saveCustomer);
      emailHandler(customer.userId);
    } else if (saveCustomer.text) {
      textHandler(customer.userId);
    } else if (saveCustomer.continue) {
      continueHandler(isURL);
    }
  }, [saveCustomer]);

  const shouldShowButtons =
    customers?.customer?.mfa_preference !== null ||
    (customers?.insuranceList?.length <= 0 &&
      !customers?.insuranceList?.[0]?.policy?.total_premium);

  console.log("customerRepull", customers, repull, shouldShowButtons);
  return (
    <>
      <Divider />
      <Box
        sx={{
          m: window.innerWidth <= 750 ? "5px" : "8px 10px 0px 15px",
        }}
      >
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.nameValidation(customer.firstName)
                ? "error"
                : "primary"
            }
          >
            First Name *
          </InputLabel>
          <OutlinedInput
            required
            label="First Name"
            value={customer.firstName}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.nameValidation(customer.firstName)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.nameValidation(customer.firstName)
              ? "Please enter a valid name"
              : " "}
          </FormHelperText>
        </FormControl>

        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.nameValidation(customer.lastName)
                ? "error"
                : "primary"
            }
          >
            Last Name *
          </InputLabel>
          <OutlinedInput
            required
            label="Last Name"
            value={customer.lastName}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.nameValidation(customer.lastName)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.nameValidation(customer.lastName)
              ? "Please enter a valid name"
              : " "}
          </FormHelperText>
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.emailValidation(customer.email)
                ? "error"
                : "primary"
            }
          >
            Email *
          </InputLabel>
          <OutlinedInput
            required
            label="Email"
            value={customer.email}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.emailValidation(customer.email)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.emailValidation(customer.email)
              ? "Please enter a valid email"
              : " "}
          </FormHelperText>
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "5px" }}>
          <InputLabel
            color={
              InputValidation.numberValidation(customer.mobileNumber)
                ? "error"
                : "primary"
            }
          >
            Mobile Number *
          </InputLabel>
          <OutlinedInput
            required={true}
            label="Mobile Number"
            value={InputValidation.phoneNumberFormat(customer.mobileNumber)}
            sx={{ borderRadius: "6px" }}
            error={InputValidation.numberValidation(customer.mobileNumber)}
          />
          <FormHelperText sx={{ color: theme.palette.error.main }}>
            {InputValidation.numberValidation(customer.mobileNumber)
              ? "Please enter a valid mobile number"
              : " "}
          </FormHelperText>
        </FormControl>
      </Box>
      {!customers ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            margin: "16px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <>
            {status === "SUCCESS" ? (
              <Box
                sx={{
                  display: "flex",

                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  m: "10px",
                }}
              >
                <CheckCircle color={"primary"} />
                <span
                  style={{
                    color: theme.palette.primary.main,
                    marginLeft: "4px",
                  }}
                >
                  Pull Completed
                </span>
              </Box>
            ) : (
              <>
                {status && status != "SUCCESS" ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      m: "10px",
                      gap: 1,
                    }}
                  >
                    <span
                      style={{
                        color:
                          status === "NOT_AUTHENTICATED" || debounceText
                            ? Theme.palette.error.main
                            : theme.palette.primary.main,
                        marginLeft: "4px",
                      }}
                    >
                      {debounceText
                        ? debounceText
                        : status === "GETTING_CONSUMERS"
                        ? "We're in! We are now pulling all your policy information"
                        : status === "NOT_AUTHENTICATED"
                        ? "Verification Failed.Please reinitiate the verification process."
                        : "Your policy information is almost complete."}
                    </span>
                  </Box>
                ) : (
                  <>
                    {customers?.customer?.mfa_preference !== null ? (
                      <></>
                    ) : (
                      <AppButton
                        variant={
                          !customers?.insuranceList[0]?.policy?.total_premium
                            ? "text"
                            : "contained"
                        }
                        buttonText={
                          !customers?.insuranceList[0]?.policy?.total_premium
                            ? "Continue here"
                            : "Submit"
                        }
                        size="medium"
                        sx={{
                          display: "flex",
                          width: "100%",
                          alignSelf: "center",
                          width: "45%",
                          m: "7px",
                        }}
                        clickHandler={() => {
                          continueHandler();
                          if (
                            customers?.customer?.mfa_preference ||
                            customers?.customer?.insurance_carrier
                          ) {
                            setLoading(true);
                          } else {
                            setLoading(false);
                          }
                        }}
                        loading={loading}
                        disabled={loading}
                      ></AppButton>
                    )}
                  </>
                )}
              </>
            )}
          </>
          {shouldShowButtons && (
            <>
              <Divider sx={{ mb: "15px" }} />
              <Box
                sx={{
                  mx: "16px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                }}
              >
                {textData?.sendTextRequest.user_id ? (
                  <Box
                    sx={{
                      display: "flex",
                      my: "14px",
                      width: "49%",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircle color={"primary"} />
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        marginLeft: "4px",
                      }}
                    >
                      TEXT SENT
                    </span>
                  </Box>
                ) : (
                  <AppButton
                    buttonText="Send Text"
                    loading={textLoading}
                    clickHandler={() => {
                      textHandler(customer?.userId);
                    }}
                    size="medium"
                    variant="outlined"
                    sx={{ width: "49%" }}
                  />
                )}
                {emailData?.sendEmailRequest.user_id ? (
                  <Box
                    sx={{
                      display: "flex",
                      my: "14px",
                      width: "49%",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircle color={"primary"} />
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        marginLeft: "4px",
                      }}
                    >
                      EMAIL SENT
                    </span>
                  </Box>
                ) : (
                  <AppButton
                    buttonText="Send Email"
                    loading={emailLoading}
                    clickHandler={() => {
                      emailHandler(customer?.userId);
                    }}
                    size="medium"
                    variant="contained"
                    sx={{ width: "49%" }}
                  />
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  p: "14px",
                }}
              >
                <Typography variant="body" fontSize={"12px"} color={"grey"}>
                  By selecting Send, you confirm that the customer has authorized
                  the dealership to send this communication by the selected method.
                </Typography>
              </Box>
            </>
          )}
        </>
      )}

      <NotificationContainer />
    </>
  );
};

export default HocPopup(RepullUsers);
